import React from 'react';
import { ShieldCheck, Scale, ScrollText, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const Legal = () => {
  return (
    <div className="min-h-screen bg-[#050505] text-white pt-32 pb-20 px-6 font-sans">
      <div className="max-w-3xl mx-auto">
        <Link to="/" className="inline-flex items-center gap-2 text-[#D4AF37] text-[10px] font-black uppercase tracking-widest mb-12 hover:opacity-70 transition-all">
          <ArrowLeft size={14} /> Back to Home
        </Link>

        <h1 className="text-5xl font-black uppercase italic tracking-tighter mb-16">
          Legal <span className="text-[#D4AF37]">Framework</span>
        </h1>

        <div className="space-y-20">
          {/* TERMS & CONDITIONS */}
          <section>
            <div className="flex items-center gap-4 mb-8 text-[#D4AF37]">
              <Scale size={24} />
              <h2 className="text-xl font-black uppercase tracking-widest italic">Terms & Conditions</h2>
            </div>
            <div className="space-y-6 text-white/60 leading-relaxed text-sm">
              <p>1. <strong className="text-white uppercase">Voting Mechanics:</strong> Each vote is cast upon successful payment of KES 10.00 via the integrated M-Pesa platform. 1 vote represents a contribution of KES 10.00.</p>
              <p>2. <strong className="text-white uppercase">Refund Policy:</strong> All votes cast are final and non-refundable. Inicus Innovations Ltd is not liable for accidental duplicate votes or incorrect nominee selection by the user.</p>
              <p>3. <strong className="text-white uppercase">Decisions:</strong> The automated system count is the final word on standings. Any disputes regarding the technical count will be audited by Inicus Innovations Ltd within 48 hours of a formal request.</p>
              <p>4. <strong className="text-white uppercase">Eligibility:</strong> Users must have legal authority over the M-Pesa line used to vote.</p>
            </div>
          </section>

          {/* PRIVACY POLICY */}
          <section>
            <div className="flex items-center gap-4 mb-8 text-[#D4AF37]">
              <ShieldCheck size={24} />
              <h2 className="text-xl font-black uppercase tracking-widest italic">Privacy Policy (ODPC Compliant)</h2>
            </div>
            <div className="space-y-6 text-white/60 leading-relaxed text-sm">
              <p>In accordance with the Kenya Data Protection Act (2019), Inicus Innovations Ltd acts as the Data Controller for the Mzinyi Taita Taveta Awards 2026.</p>
              <p>1. <strong className="text-white uppercase">Data Collection:</strong> We collect M-Pesa transaction details (Phone number, Name, and Amount) solely for vote verification and auditing purposes.</p>
              <p>2. <strong className="text-white uppercase">Use of Data:</strong> Your data will NEVER be sold, shared, or used for third-party marketing. It is strictly used to attribute votes to the chosen nominee.</p>
              <p>3. <strong className="text-white uppercase">Retention:</strong> Transaction logs are kept for 90 days following the Grand Gala for audit purposes, after which personal identifiable information is archived securely.</p>
            </div>
          </section>

          {/* COMPANY INFO */}
          <div className="p-8 border border-white/5 bg-white/[0.02] rounded-3xl opacity-50 text-[10px] font-bold uppercase tracking-widest">
            <p>Administered by: Inicus Innovations Limited</p>
            <p className="mt-2 text-[#D4AF37]">Taita Taveta, Kenya</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Legal;